import React, { Component, Fragment } from "react";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";

import IntlMessages from "Util/IntlMessages";
import { injectIntl } from 'react-intl';
var classNames = require('classnames');
import StateButton from "Components/StateButton";

import {
    logoutUser
} from "Redux/actions";
import { connect } from "react-redux";

import API from '../../../api/index';
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import 'react-sortable-tree/style.css';
import CustomSelectInput from "Components/CustomSelectInput";
import { NotificationManager } from "Components/ReactNotifications";

import Select from "react-select";
import {
    Row,
    Button,
    FormGroup,
    Label,
    Progress,
    Input,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Col
} from "reactstrap";

import { Colxx } from "Components/CustomBootstrap";

class CustomerAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ProcessIndex: -1,
            isSaving: false,
            BulkLeadMobiles: [],
            ListPulseTags: [],
            PulseTag: -1
        };

        this.appendNewNumbers = this.appendNewNumbers.bind(this);
        this.cleanCustomerMobile = this.cleanCustomerMobile.bind(this);
        this.validateMobile = this.validateMobile.bind(this);
        this.addLead = this.addLead.bind(this);
        this.validateLeadList = this.validateLeadList.bind(this);
        this.processNext = this.processNext.bind(this);
        this.updateMobileItemState = this.updateMobileItemState.bind(this);
        this.saveLeads = this.saveLeads.bind(this);
        this.listPulseTags = this.listPulseTags.bind(this);

        this.listPulseTags();
    }

    listPulseTags() {

        API.crm.lead.listPulseTags()
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

                if (data.ERRORS !== undefined) {
                    for (var i = 0; i < data.ERRORS.length; i++) {
                        setTimeout(function (err) {
                            NotificationManager.error(
                                err,
                                "خطا در ثبت سرنخ ها",
                                8000, null, null, "filled");
                        }, (i + 1) * 700, data.ERRORS[i]);
                        this.setState({
                            isLoading: false
                        });
                    }
                } else {
                    this.setState({
                        isLoading: false,
                        ListPulseTags: data.ListPulseTags
                    })
                }
            })
            .catch(error => { });
    }

    saveLeads() {
        this.setState({
            isSaving: true,
            ProcessIndex: -1
        });
        this.processNext();
        return;


    }
    processNext() {
        var Index = this.state.ProcessIndex + 1;
        this.setState({ ProcessIndex: Index });
        if (Index == this.state.BulkLeadMobiles.length) {
            this.setState({
                isSaving: false
            });
            return;
        }


        this.updateMobileItemState(Index, "saving");


        API.crm.lead.add({ Lead: this.state.BulkLeadMobiles[Index], PulseTagID: this.state.PulseTag })
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

                if (data.ERRORS !== undefined) {
                    for (var i = 0; i < data.ERRORS.length; i++) {
                        setTimeout(function (err) {
                            NotificationManager.error(
                                err,
                                "خطا در ثبت سرنخ ها",
                                8000, null, null, "filled");
                        }, (i + 1) * 700, data.ERRORS[i]);
                    }
                }

                console.log(data.RESPONSE.LEAD);
                switch (data.RESPONSE.LEAD) {
                    case "ALREADY_LEAD":
                        this.updateMobileItemState(this.state.ProcessIndex, "alreadylead");
                        break;
                    case "SUCCESS":
                        this.updateMobileItemState(this.state.ProcessIndex, "saved");
                        break;
                    case "ALREADY_CUSTOMER":
                        this.updateMobileItemState(this.state.ProcessIndex, "alreadycustomer");
                        break;
                    default:
                        this.updateMobileItemState(this.state.ProcessIndex, "error");
                        break;
                }

                this.processNext();
            })
            .catch(error => { });


        /* setTimeout(() => {
            var randomState = Math.floor(Math.random() * 4);
            var States = [];
            States.push("saved");
            States.push("error");
            States.push("alreadylead");
            States.push("alreadycustomer");
            this.updateMobileItemState(Index, States[randomState]);
            this.processNext();
        }, 500);*/
    }
    updateMobileItemState(Index, State) {
        var MobileItems = this.state.BulkLeadMobiles;
        MobileItems[Index].State = State;
        this.setState({ BulkLeadMobiles: MobileItems });
    }
    validateLeadList() {
        return this.state.BulkLeadMobiles.length > 0;
    }
    addLead() {
        this.setState({ isSaving: true });
        this.processNext();
    }
    validateMobile(mobile) {
        if (mobile.trim() == "") {
            return false;
        }
        return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
    }
    appendNewNumbers(numbers) {
        var Numbers = (numbers).split("\n");
        var NumberList = [];
        for (var i = 0; i < Numbers.length; i++) {
            var CleanMobile = this.cleanCustomerMobile(Numbers[i]);
            if (this.validateMobile(CleanMobile)) {
                NumberList.push({ Mobile: CleanMobile, State: "ready", Index: i });
            }
        }
        this.setState({ BulkLeadMobiles: NumberList });
    }
    cleanCustomerMobile(mobile) {
        mobile = mobile.split(" ").join("");
        mobile = mobile.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

        // console.log(mobile,mobile.indexOf("0098"))
        if (mobile.indexOf("0098") === 0) {
            mobile = mobile.replace("0098", "0");
        }
        if (mobile.indexOf("098") === 0) {
            mobile = mobile.replace("098", "0");
        }
        if (mobile.indexOf("+98") === 0) {
            mobile = mobile.replace("+98", "0");
        }
        if (mobile.indexOf("98") === 0) {
            mobile = mobile.replace("98", "0");
        }
        if (mobile.indexOf("9") === 0 && mobile.length == 10) {
            mobile = "0" + mobile;
        }
        return mobile;
    }
    render() {
        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row className="mb-4">
                        <Colxx xxs="2">
                        </Colxx>
                        <Colxx xxs="8">
                            <Card>
                                <CardBody>
                                    <CardTitle>
                                        <div onClick={(e) => { this.props.history.push("/app/crm/lead/"); }} className="breadcrumb-item">
                                            <div className={"iconsminds-leaning-tower headingicon"} /> سرنخ ها
                                        </div>
                                        <span className="breadcrumb-arrow" style={{ marginLeft: "10px" }}>{" > "}</span>
                                        <div className={"simple-icon-plus headingicon"} />
                                        ثبت عمده سرنخ ها


                                    </CardTitle>


                                    <Row className="mb-4">

                                        <Colxx sm={6}>
                                            <FormGroup className={"filter"}>
                                                <label>
                                                    لیست شماره موبایل ها (در هر خط یک شماره)
                                                </label>


                                                <textarea
                                                    autoComplete="off"
                                                    type="text"
                                                    name="BulkLeadMobiles"
                                                    id="BulkLeadMobiles"
                                                    disabled={this.state.isSaving}
                                                    placeholder=""
                                                    rows={4}
                                                    style={{ "width": "100%", "direction": "ltr" }}
                                                    value={""}
                                                    onChange={(e) => { this.appendNewNumbers(e.target.value); }}

                                                >
                                                    {""}
                                                </textarea>

                                                <Select
                                                    components={{ Input: CustomSelectInput }}
                                                    className={classNames({ "react-select": true, "react-select-error": (this.state.PulseTag === -1) })}
                                                    // classNamePrefix="react-select"
                                                    isMulti={false}
                                                    name="form-field-name"
                                                    placeholder={"پالس مرتبط را انتخاب کنید"}
                                                    disabled={this.state.isSaving}
                                                    onChange={(e) => { this.setState({ PulseTag: e.id }) }}
                                                    options={this.state.ListPulseTags}
                                                />
                                            </FormGroup>
                                        </Colxx>
                                        <Colxx sm={6}>
                                            <FormGroup className={"filter"} style={{ background: "rgb(245,254,255)", borderColor: "#d0fbff" }}>
                                                <label>
                                                    راهنمای نتایج
                                                </label>

                                                <Row>
                                                    <Colxx sm={6}>
                                                        <FormGroup className={"filter mobile-item-state-error"}>
                                                            <label className={"mobile-number"}>
                                                                مشکل در ثبت
                                                            </label>
                                                        </FormGroup>
                                                    </Colxx>
                                                    <Colxx sm={6}>
                                                        <FormGroup className={"filter mobile-item-state-saved"}>
                                                            <label className={"mobile-number"}>
                                                                ذخیره شد
                                                            </label>
                                                        </FormGroup>
                                                    </Colxx>
                                                    <Colxx sm={6}>
                                                        <FormGroup className={"filter mobile-item-state-alreadylead"}>
                                                            <label className={"mobile-number"}>
                                                                سرنخ تکراری
                                                            </label>
                                                        </FormGroup>
                                                    </Colxx>
                                                    <Colxx sm={6}>
                                                        <FormGroup className={"filter mobile-item-state-alreadycustomer"}>
                                                            <label className={"mobile-number"}>
                                                                مشتری
                                                            </label>
                                                        </FormGroup>
                                                    </Colxx>

                                                </Row>
                                            </FormGroup>
                                        </Colxx>
                                        <Colxx xxs="12">
                                            <Row>

                                                <Colxx xxs={9}>
                                                    <Progress value={(this.state.ProcessIndex / this.state.BulkLeadMobiles.length) * 100} />
                                                    <div style={{ marginTop: "10px" }}>
                                                        {Math.min(this.state.ProcessIndex + 1, this.state.BulkLeadMobiles.length)} / {this.state.BulkLeadMobiles.length}
                                                    </div>
                                                </Colxx>

                                                <Colxx xxs={3}>
                                                    <Button color="primary" className="default mb-2 btn-shadow" style={{ "float": "left" }} disabled={this.state.isSaving || !this.validateLeadList() || this.state.PulseTag == -1} onClick={(e) => { this.saveLeads() }}>
                                                        ثبت سرنخ
                                                    </Button>
                                                    {" "}
                                                    <div className="loading loading-inline" style={{ display: this.state.isSaving ? "inline-block" : "none", "marginLeft": "5px" }}></div>
                                                    {" "}
                                                </Colxx>
                                            </Row>


                                        </Colxx>
                                        <Colxx sm={12}>
                                            <Row>
                                                {this.state.BulkLeadMobiles.map((item, index) => {
                                                    return <Colxx sm={3} key={index}>
                                                        <FormGroup className={"filter mobile-item-state-" + item.State}>
                                                            <label className={"mobile-number"}>
                                                                {item.Mobile}
                                                            </label>
                                                        </FormGroup>
                                                    </Colxx>
                                                })
                                                }

                                            </Row>
                                        </Colxx>





                                    </Row>
                                </CardBody>
                            </Card>

                        </Colxx>

                    </Row>
                </Fragment>
        );
    }
}


const mapStateToProps = ({ menu, settings }) => {
    return { logoutUser };
};
export default injectIntl(connect(
    mapStateToProps,
    { logoutUser }
)(CustomerAdd));
// export default injectIntl(ProductPriceManager);